import useFetchSelect from 'elements/Hooks/useFetchSelect'
import { GlobalContext } from 'Global'
import React from 'react'

function Organisations(props) {
  const { tenantGroup = {} } = React.useContext(GlobalContext)

  const { SelectData: OrganisationsSelect } = useFetchSelect({
    url: 'corporates/',
    dependencyArray: [tenantGroup._id],
  })

  return (
    <OrganisationsSelect placeholder={'Select a company'} keyAtr={props.keyAtr || '_id'} valueAtr={'fn'} {...props} />
  )
}

export default Organisations

